import React from 'react';
import '../App.css';
import './Home.css';

function Contacts() {
    return (
        <main className="centered-container">
            <h1>Contact</h1>
            <p>
                Best way to reach me is email. LinkedIn is also there if you prefer the more normal route.
            </p>

            <div className="contact-list">
                <div className="contact-row">
                    <img
                        src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linkedin/linkedin-original.svg"
                        alt=""
                    />
                    <a href="https://www.linkedin.com/in/gon%C3%A7alo-ferraz-9aba24274/">LinkedIn</a>
                </div>

                <div className="contact-row">
                    <span aria-hidden="true">Mail</span>
                    <a href="mailto:gjsferraz@gmail.com">gjsferraz@gmail.com</a>
                </div>
            </div>
        </main>
    );
}

export default Contacts;
